import {
  AOOSShopperStatus,
  BatchDetailTabs,
  GroupedAssignedItems,
  OrderItemStatus,
  ReceiptBypassMode,
  itemsForSection,
  itemsSortBy,
} from '../types';
import {Box, HBox} from '../../components/core/view';
import {
  ClientType,
  getClientType,
  getStoreName,
} from '@buncha/common/types/common';
import {HomeScreens, ShopperScreens} from '../../home/navigation/types';
import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {StyleSheet} from 'react-native';
import {
  batchDetailActionsLocal,
  useBatchDetailReducer,
} from '../hooks/batchDetail';
import {
  useAdjacentOOSItems,
  useGetOrdersForOrderAssigneeCount,
  useGetRunForBatchDetail,
  useUPCShift,
} from '../hooks/BatchDetails';

import AddBottomSheet from '../addBottomSheet';
import {Analytics} from '../../config/analytics/analytics';
import AppModal from '@buncha/common/components/CustomModal/AppModal';
import {BatchDetailContext} from '../context/BatchDetailContext';
import BatchDetailHeader from '../component/BatchDetailHeader';
import BatchScreenComponent from '../components/BatchScreenComponent/BatchScreenComponent';
import ChatBottomsheet from '@buncha/itemDetails/components/ItemDetail/contactBottomSheet/ChatBottomsheet';
import {ChatModes} from '../types/Chat';
import ChatOpener from '@buncha/components/composites/ChatOpener';
import {CommonScreens} from '@buncha/common/navigation/types';
import {CustomItemMode} from '@buncha/itemDetails/types/CustomItem';
import CustomModal from '@buncha/common/components/CustomModal/CustomModal';
import DoneItemList from '../component/DoneItemList';
import {EventType} from '../../config/analytics/type';
import {H6Text} from '@buncha/components/core/text';
import Header from '../../components/composites/Header/Header';
import If from '../../components/conditional/If';
import {ItemDetailsScreen} from '@buncha/itemDetails/navigation/types';
import LocateItemList from '../component/locateItemList';
import {MainScreens} from '@buncha/navigation/types';
import {Modules} from '@buncha/utils/types';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {ONE_DAY_TIMEOUT_MS} from '@buncha/config/utils/constants';
import PassOrderModal from '../component/PassOrderModal/PassOrderModal';
import PdfIcon from '../../components/core/icon/PdfIcon';
import ReceiptIcon from '../../components/core/icon/ReceiptIcon';
import ScreenHeader from '../../common/components/screenHeader';
import SortBar from '../component/SortBar';
import {SpinnerComponent} from '../../components/core/loader';
import {StorageKeys} from '@buncha/config/storage/type';
import StoreMapIcon from '@buncha/components/core/icon/StoreMapIcon';
import Tab from '../../components/composites/Tabs/Tab';
import {TabNode} from '../../components/shared/TabNode';
import TodoItemList from '../component/TodoItemList';
import {Touchable} from '../../components/core/touchable';
import {UserTypes} from '@buncha/onBoarding/types';
import font from '@buncha/appStyles/style/font';
import {isWeb} from '@buncha/utils/common';
import listener from '../../config/listener';
import {navigation} from '../../config/navigation';
import {storage} from '@buncha/config/storage';
import {useAppSelector} from '@buncha/config/redux/hooks';
import {useColorThemeType} from '../../appStyles/hooks/theme';
import {useGetItemStatusCount} from '../hooks/OrderOperation';
import {useGetLocale} from '@buncha/localization/hooks';
import {useIsFocused} from '@react-navigation/native';
import {useIsMeijerStore} from '@buncha/home/hooks/home';

type Props = NativeStackScreenProps<any, any>;

const BatchDetailsPage = (props: Props) => {
  const theme = useColorThemeType('main');
  const [open, setOpen] = useState(false);
  const keyRef = useRef('');
  const [state, dispatch] = useBatchDetailReducer();
  const provider = useMemo(() => ({state, dispatch}), [dispatch, state]);
  const {
    DROP_MODAL_CONFIG,
    AOOS_SNOOZE_TIMER,
    adjOOSIdsOpened,
    isSubsNavigationEnabled,
  } = useAppSelector(gState => ({
    DROP_MODAL_CONFIG: gState.onboarding.constants?.DROP_MODAL_CONFIG,
    AOOS_SNOOZE_TIMER: gState.onboarding.constants?.AOOS_SNOOZE_TIMER,
    adjOOSIdsOpened: gState.home.adjOOSIdsOpened,
    isSubsNavigationEnabled:
      gState.onboarding.constants?.ADJ_OOS_BACK_NAVIGATION,
  }));

  const [getRunForBatchDetail, runState] = useGetRunForBatchDetail(dispatch);
  const {getOrderItemsCount} = useGetOrdersForOrderAssigneeCount(dispatch);
  const {orderLoading} = useUPCShift(dispatch);
  const isFocus = useIsFocused();
  const [hasNavigateToBack, setHasNavigateToBack] = useState(false);
  const [currentTab, setCurrentTab] = useState<string>();
  const {getAdjacentOOSItems} = useAdjacentOOSItems(dispatch);
  const {title, body, button} =
    useGetLocale(Modules.batchDetails, ShopperScreens.BatchDetailsPage) ?? {};
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const [timeLeftSec, setTimeLeftSec] = useState<number>(0);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [getItemStatusCount] = useGetItemStatusCount(null);

  const disableTodo = state.disableToDo;

  const tabDataCount = state.tabDataCount;
  const locateItems = state.groupedAssignedItems.locate;
  const sentItems = state.groupedAssignedItems.sent;

  const contactBottomSheetProps = state.contactSheetProps;
  const storeMapsString = useAppSelector(
    gState => gState.onboarding.constants?.B2B_STORE_MAPS,
  );

  const params = props.route.params;
  const runId = Number(params?.runId) || 0;
  const isUPCMode = params?.isUPCMode || false;
  const upcOrderId = params?.upcOrderId || 0;
  const storeId = runState?.data?.store?.id ?? 0;

  const storeMap = useMemo(() => {
    const storeMaps = storeMapsString ? JSON.parse(storeMapsString) : {};
    return storeMaps[storeId];
  }, [storeId, storeMapsString]);

  const isMeijerStore = useIsMeijerStore(storeId);
  const sections: {[key: string]: React.ReactElement} = {};
  const tabHeader = [
    BatchDetailTabs.todo,
    BatchDetailTabs.locate,
    BatchDetailTabs.sent,
    BatchDetailTabs.done,
  ];
  const dropModalConfig = useMemo(() => {
    return JSON.parse(DROP_MODAL_CONFIG || '{}');
  }, [DROP_MODAL_CONFIG]);

  const closeContactSheet = useCallback(() => {
    if (dispatch)
      dispatch(batchDetailActionsLocal.setContactBottomSheetProps(undefined));
  }, [dispatch]);

  const navigateToReceiptScreen = useCallback(() => {
    Analytics.eventWithProps('Open Receipt Modal', {
      type: EventType.cta,
      runId,
      cleint: getClientType(isMeijerStore),
    });
    setOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkTimeDifference = useCallback(async () => {
    const storedTimeStamp = await storage.getItem(StorageKeys.lastDropItemTime);
    if (storedTimeStamp) {
      const storedTime = new Date(storedTimeStamp).getTime();
      const currentTime = new Date().getTime();
      const timeDifference = currentTime - storedTime;

      const tenMinutesInMs = 10 * 60 * 1000;
      if (timeDifference >= tenMinutesInMs) return true;
      const timeRemaining = tenMinutesInMs - timeDifference;
      const timeRemainingInMinutes = Math.ceil(timeRemaining / (60 * 1000));
      const timeRemainingInSeconds = Math.ceil(timeRemaining / 1000);
      setTimeLeft(timeRemainingInMinutes);
      setTimeLeftSec(timeRemainingInSeconds);
      return false;
    }
    return true;
  }, []);

  const submitReceipt = useCallback(async () => {
    const canUploadReceipt = await checkTimeDifference();
    if (canUploadReceipt) return navigateToReceiptScreen();
    setIsModalVisible(true);
  }, [checkTimeDifference, navigateToReceiptScreen]);

  const closeModal = useCallback(() => {
    setOpen(false);
    if (dispatch)
      dispatch(
        batchDetailActionsLocal.setSkippedReceiptFlow(
          ReceiptBypassMode.skipByShopper,
        ),
      );
    if (runId) getRunForBatchDetail(runId);
  }, [dispatch, getRunForBatchDetail, runId]);

  const skipReceiptFlowHandler = useCallback(() => {
    if (dispatch) {
      dispatch(
        batchDetailActionsLocal.setSkippedReceiptFlow(
          ReceiptBypassMode.skipByShopper,
        ),
      );
      closeModal();
    }
  }, [closeModal, dispatch]);

  const renderComponent = useMemo(() => {
    if (open)
      return (
        <BatchScreenComponent
          runState={runState.data}
          isOpen={open}
          onClose={closeModal}
          runId={runId}
          hasSkip={state?.hasSkipReceipt}
          hasSkipReceiptHandler={skipReceiptFlowHandler}
        />
      );
  }, [
    closeModal,
    open,
    runId,
    runState.data,
    skipReceiptFlowHandler,
    state?.hasSkipReceipt,
  ]);

  const navigateToPdfDetailScreen = useCallback(() => {
    Analytics.eventWithProps('Navigate to PDF', {
      type: EventType.cta,
      runId,
      client: getClientType(isMeijerStore),
    });
    navigation.navigate(ShopperScreens.PdfDetailScreen, {
      runId: runId ?? '',
    });
  }, [isMeijerStore, runId]);

  useEffect(() => {
    if (runId) getRunForBatchDetail(runId);
    if (params?.tutorial === 'true' && dispatch)
      dispatch(batchDetailActionsLocal.setTutorial(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [runId]);

  const updateItemStatusCount = useCallback(async () => {
    if (currentTab && runId)
      if (currentTab === BatchDetailTabs.todo) {
        const count = await getItemStatusCount(runId, [
          OrderItemStatus.picked,
          OrderItemStatus.dropped,
        ]);
        dispatch(batchDetailActionsLocal.setUPCItemsDone(count?.[0] || 0));
      } else if (currentTab === BatchDetailTabs.done) {
        const count = await getItemStatusCount(runId, [
          OrderItemStatus.notPicked,
          OrderItemStatus.missing,
        ]);
        dispatch(batchDetailActionsLocal.setToDoCount(count?.[0] || 0));
      }
  }, [currentTab, dispatch, getItemStatusCount, runId]);

  useEffect(() => {
    updateItemStatusCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocus, currentTab]);

  const navigateToAddItem = useCallback(
    (item?: GroupedAssignedItems) => {
      closeContactSheet();
      if (isMeijerStore && !state.addItem)
        return dispatch(batchDetailActionsLocal.setAddItem(item));
      const orderId = item?.orderItems?.length
        ? item?.orderItems[0]?.orderId
        : 0;
      const storeIndex = runState?.data?.store?.elasticSearchIndex || '';
      if (!runId || !storeId || !orderId) return;
      if (!runState?.data?.store?.elasticSearchIndex?.length) {
        Analytics.eventWithProps('Navigate to Add Custom Item', {
          type: EventType.cta,
          runID: runId,
          orderId,
          storeId,
          cleint: getClientType(isMeijerStore),
        });

        return navigation.navigate(ShopperScreens.ItemDetails, {
          screen: ItemDetailsScreen.CustomItem,
          params: {
            orderId,
            runId,
            mode: CustomItemMode.addItem,
          },
        });
      }
      Analytics.eventWithProps('Navigate to Add Item', {
        type: EventType.cta,
        runID: runId,
        orderId,
        storeId,
        cleint: getClientType(isMeijerStore),
      });
      navigation.navigate(ShopperScreens.AddItemPage, {
        storeId,
        runId,
        orderId,
        storeIndex,
      });
    },
    [
      closeContactSheet,
      isMeijerStore,
      state.addItem,
      dispatch,
      runState?.data?.store?.elasticSearchIndex,
      runId,
      storeId,
    ],
  );

  const moveToDone = useCallback(() => {
    return setCurrentTab(BatchDetailTabs.done);
  }, []);

  tabHeader.forEach(tab => {
    switch (tab) {
      case BatchDetailTabs.todo:
        sections[tab] = (
          <TodoItemList
            isUPCMode={isUPCMode}
            runDetail={runState.data ?? undefined}
            upcOrderId={upcOrderId}
            navigateToAddItem={navigateToAddItem}
          />
        );
        break;
      case BatchDetailTabs.locate:
        sections[tab] = (
          <LocateItemList
            moveToDone={moveToDone}
            runDetail={runState.data ?? undefined}
          />
        );
        break;
      case BatchDetailTabs.sent:
        sections[tab] = (
          <LocateItemList
            moveToDone={moveToDone}
            runDetail={runState.data ?? undefined}
            sentList
          />
        );
        break;
      case BatchDetailTabs.done:
        sections[tab] = (
          <DoneItemList
            isUPCMode={isUPCMode}
            runDetail={runState.data ?? undefined}
            upcOrderId={upcOrderId}
            navigateToReceiptScreen={submitReceipt}
            navigateToAddItem={navigateToAddItem}
          />
        );
        break;
      default:
        sections[BatchDetailTabs.todo] = (
          <TodoItemList
            isUPCMode={isUPCMode}
            runDetail={runState.data ?? undefined}
            upcOrderId={upcOrderId}
            navigateToAddItem={navigateToAddItem}
          />
        );
    }
  });

  const tabNode = useCallback((info: any, activeKey: any) => {
    return <TabNode info={info} activeKey={activeKey} />;
  }, []);

  const refreshCount = useCallback(() => {
    getOrderItemsCount(runId, itemsForSection.todo, state.sortBarValue);
  }, [getOrderItemsCount, runId, state.sortBarValue]);

  useEffect(() => {
    const unsubscribe = listener.addListener('itemUpdate', refreshCount);
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLocateCount = useCallback(async () => {
    getAdjacentOOSItems('sent', runId);
    const uncheckedItem = await getAdjacentOOSItems('locate', runId);
    const storedData = await storage.getItem(StorageKeys.snoozeTimer);
    const storedItems = await storage.getItem(StorageKeys.snoozedItems);
    const snoozeTimerData = JSON.parse(storedData || '{}');
    const snoozedItems = JSON.parse(storedItems || '{}');
    const now = new Date().getTime();
    const timerMinutes = parseInt(AOOS_SNOOZE_TIMER ?? '', 10) || 5;
    const itemToOpen = uncheckedItem?.find(item => {
      if (isSubsNavigationEnabled === 'true')
        return !adjOOSIdsOpened.includes(item.adjacentOOS?.id);
      const snoozedTime = snoozeTimerData[item?.adjacentOOS?.id];
      let timeDiff = false;
      if (snoozedTime) {
        const timeDifference = Math.floor(
          (now - new Date(snoozedTime as string).getTime()) / 60000,
        );
        timeDiff = timeDifference >= timerMinutes;
        return timeDiff;
      }
      return true;
    });
    const fiveMinutesInMs = timerMinutes * 60 * 1000;
    const updatedSnoozeTimerData = Object.fromEntries(
      Object.entries(snoozeTimerData).filter(([_, time]) => {
        const itemTime = new Date(time as string).getTime();
        return now - itemTime <= fiveMinutesInMs;
      }),
    );
    await storage.setItem(
      StorageKeys.snoozeTimer,
      JSON.stringify(updatedSnoozeTimerData),
    );
    const updatedSnoozedItemsData = Object.fromEntries(
      Object.entries(snoozedItems).filter(([_, time]) => {
        const itemTime = new Date(time as string).getTime();
        return now - itemTime <= ONE_DAY_TIMEOUT_MS;
      }),
    );
    await storage.setItem(
      StorageKeys.snoozedItems,
      JSON.stringify(updatedSnoozedItemsData),
    );
    if (
      uncheckedItem?.length &&
      itemToOpen?.adjacentOOS?.id &&
      itemToOpen?.shopperStatus === AOOSShopperStatus.itemShared
    )
      navigation.navigate(ShopperScreens.ItemDetails, {
        screen: ItemDetailsScreen.SubstituteItemDetailPage,
        params: {
          catalogItemId: itemToOpen?.orderItem?.catalogItemId,
          orderItemId: itemToOpen?.orderItem?.id,
          storeIndex: runState?.data?.store?.elasticSearchIndex,
          runId: runState?.data?.id,
          adjacentOOSId: itemToOpen?.adjacentOOS?.id,
        },
      });
  }, [
    adjOOSIdsOpened,
    getAdjacentOOSItems,
    runId,
    AOOS_SNOOZE_TIMER,
    isSubsNavigationEnabled,
    runState?.data?.store?.elasticSearchIndex,
    runState?.data?.id,
  ]);

  useEffect(() => {
    if (runId)
      Analytics.eventWithProps('Batch Details Screen', {
        type: EventType.page,
        runID: runId,
        storeName: runState?.data?.storeName,
        sortBy: state.sortBarValue || itemsSortBy.category,
        status: 'In Picking Status',
        client: getClientType(isMeijerStore),
        storeType: getStoreName(String(storeId)),
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [runId]);

  useEffect(() => {
    if (storeId && !isMeijerStore && isFocus) handleLocateCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [runId, isFocus, storeId]);

  const navigateToCheckTask = useCallback(() => {
    dispatch(batchDetailActionsLocal.setPickedOrderFoundModal(false));
    setHasNavigateToBack(true);
  }, [dispatch]);

  const tabData = useMemo(() => {
    const tabs = [
      {
        key: BatchDetailTabs.todo,
        data: tabDataCount?.todoCount
          ? title?.todoCount?.replace('{todoCount}', tabDataCount?.todoCount)
          : title?.todo,
      },
    ];
    if (locateItems?.length)
      tabs.push({
        key: BatchDetailTabs.locate,
        data: title?.locateCount?.replace('{locateCount}', locateItems?.length),
      });

    if (sentItems?.length)
      tabs.push({
        key: BatchDetailTabs.sent,
        data: title?.sentCount?.replace(
          '{locateCount}',
          sentItems?.length?.toString(),
        ),
      });
    tabs.push({
      key: BatchDetailTabs.done,
      data: tabDataCount.doneCount
        ? title?.doneCount?.replace('{doneCount}', tabDataCount?.doneCount)
        : title?.done,
    });

    return tabs;
  }, [
    locateItems?.length,
    sentItems?.length,
    tabDataCount.doneCount,
    tabDataCount?.todoCount,
    title?.done,
    title?.doneCount,
    title?.locateCount,
    title?.sentCount,
    title?.todo,
    title?.todoCount,
  ]);

  useEffect(() => {
    if (hasNavigateToBack && !state.hasPickedOrderModal) {
      navigation.replace(HomeScreens.Shopper, {
        screen: ShopperScreens.BatchDetailsPage,
        params: {runId: runId},
      });
      setHasNavigateToBack(false);
    }
  }, [hasNavigateToBack, runId, state.hasPickedOrderModal]);

  useEffect(() => {
    let hasTodo = BatchDetailTabs.done;
    if (sentItems?.length > 0) hasTodo = BatchDetailTabs.sent;
    if (locateItems?.length > 0) hasTodo = BatchDetailTabs.locate;
    setCurrentTab(disableTodo ? hasTodo : undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disableTodo]);

  const clearAddItem = useCallback(
    () => dispatch(batchDetailActionsLocal.setAddItem(undefined)),
    [dispatch],
  );

  useEffect(() => {
    if (!locateItems?.length)
      setCurrentTab(disableTodo ? BatchDetailTabs.done : BatchDetailTabs.todo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locateItems?.length]);

  const viewStoreMap = useCallback(() => {
    Analytics.eventWithProps('store map', {
      type: EventType.cta,
      client: ClientType.meijer,
      storeType: getStoreName(String(storeId)),
      source: 'Store Map',
    });
    navigation.navigate(MainScreens.Common, {
      screen: CommonScreens.ImagePreview,
      params: {imageUrl: storeMap, isMap: true},
    });
  }, [storeMap, storeId]);

  const closeDropTimerModal = useCallback(() => {
    setIsModalVisible(false);
  }, []);

  const moveToRecieptScreen = useCallback(() => {
    if (isModalVisible) setIsModalVisible(false);
    return navigateToReceiptScreen();
  }, [isModalVisible, navigateToReceiptScreen]);

  const modalTitle = useMemo(() => {
    if (timeLeft || timeLeftSec) {
      const timeUnit = timeLeft
        ? `${timeLeft} minutes`
        : `${timeLeftSec} seconds`;
      return dropModalConfig?.subtitle?.replace(':timeUnit:', timeUnit);
    }
    return '';
  }, [dropModalConfig?.subtitle, timeLeft, timeLeftSec]);

  return (
    <BatchDetailContext.Provider value={provider}>
      <Header
        loading={runState.loading}
        showDefaultLeftHeader
        headerRightComponent={
          <If condition={!isUPCMode}>
            <HBox style={[styles.headerIconContainer]}>
              <If condition={!isMeijerStore && storeId}>
                <Touchable onPress={submitReceipt}>
                  <ReceiptIcon
                    fill={theme?.background.gray[100]}
                    viewBox="-4 -10 25 25"
                  />
                </Touchable>
              </If>
              <If condition={!isMeijerStore && storeId}>
                <Touchable onPress={navigateToPdfDetailScreen}>
                  <PdfIcon
                    fill={theme?.background.gray[100]}
                    viewBox="0 -5 25 25"
                    style={[styles.rightIcon]}
                  />
                </Touchable>
              </If>
              <If condition={!isWeb() && !isMeijerStore && storeId}>
                <ChatOpener
                  hideRole={UserTypes.driver}
                  mode={ChatModes.run}
                  runId={isFocus ? runId : undefined}
                  style={styles.chatIcon}
                />
              </If>
              <If condition={isMeijerStore}>
                <Touchable
                  onPress={viewStoreMap}
                  style={[
                    styles.storeMapBox,
                    {borderColor: theme?.text.blue[100]},
                  ]}>
                  <StoreMapIcon
                    height={24}
                    width={24}
                    viewBox="-2 -2 27 27"
                    fill={theme?.background.blue[100]}
                  />
                  <H6Text style={{color: theme?.text.blue[100]}}>
                    Store Map
                  </H6Text>
                </Touchable>
              </If>
            </HBox>
          </If>
        }
        headerColor={theme?.background.blue[300]}>
        <If condition={isUPCMode}>
          <ScreenHeader title={title?.UPCShift} />
        </If>
        <Box style={styles.contentBox}>
          <If condition={runState.loading || orderLoading}>
            <Box style={styles.loaderStyle}>
              <SpinnerComponent size={'large'} />
            </Box>
          </If>
          <If
            condition={
              (!isUPCMode && !runState.loading) || (isUPCMode && !orderLoading)
            }>
            <If condition={runState.data || state?.upcOrderData?.upcOrder}>
              <BatchDetailHeader
                showRunPill={!isUPCMode}
                runDetail={runState.data ?? undefined}
                upcOrderData={state?.upcOrderData?.upcOrder}
              />
            </If>
            <If
              condition={
                state.showSortBar || state?.upcOrderData?.orderItems?.length
              }>
              <SortBar isMeijer={isMeijerStore} upcMode={isUPCMode} />
            </If>
            <Tab
              key={keyRef.current}
              activeKey={currentTab}
              tabData={tabData}
              sections={sections}
              style={styles.tabContainer}
              tabNode={tabNode}
              setActiveKey={setCurrentTab}
            />
          </If>
          {renderComponent}
        </Box>

        <If condition={contactBottomSheetProps}>
          <ChatBottomsheet
            isOpen={Boolean(contactBottomSheetProps)}
            onClose={closeContactSheet}
            orderId={contactBottomSheetProps?.orderId}
            runId={runId}
            storeId={storeId}
            orderItemId={contactBottomSheetProps?.orderItemId}
          />
        </If>

        <If condition={state?.hasPickedOrderModal}>
          <CustomModal
            open={state?.hasPickedOrderModal}
            onClose={() => {
              dispatch(batchDetailActionsLocal.setPickedOrderFoundModal(false));
            }}>
            <PassOrderModal
              onContinueClick={() => navigateToCheckTask()}
              title={title?.actionRequired}
              ctaTitle={button?.checkTask}
              subtitle={body?.checkOrders}
            />
          </CustomModal>
        </If>
        <If condition={isModalVisible}>
          <AppModal
            isOpen={isModalVisible}
            onClose={closeDropTimerModal}
            topCTAHandelr={closeDropTimerModal}
            bottomCTAHandelr={moveToRecieptScreen}
            hideBottomCta={!dropModalConfig?.bottomCTA?.length}
            title={dropModalConfig?.title}
            subTitle={modalTitle}
            subTitleStyle={styles.subHeaderTypo}
            ctaBottomTitle={dropModalConfig?.bottomCTA}
            ctaTopTitle={dropModalConfig?.topCTA}
            topCTAColor={theme?.background.green[100]}
            storeId={storeId}
          />
        </If>

        <If condition={state.addItem}>
          <AddBottomSheet
            storeIndex={runState.data?.store?.elasticSearchIndex}
            open={Boolean(state.addItem)}
            onClose={clearAddItem}
            navigateToAddScreen={navigateToAddItem}
            item={state.addItem}
            orderId={state.addItem?.metaData?.orderId}
            runId={runId}
            storeId={runState.data?.store?.id}
          />
        </If>
      </Header>
    </BatchDetailContext.Provider>
  );
};

export default React.memo(BatchDetailsPage);

const styles = StyleSheet.create({
  headerIconContainer: {
    marginRight: 20,
    marginTop: 5,
  },
  rightIcon: {
    marginLeft: 15,
  },
  tabContainer: {
    marginTop: 15,
    borderWidth: 2,
    height: '100%',
  },
  contentBox: {
    height: '100%',
    flex: 1,
  },
  loaderStyle: {flex: 1, justifyContent: 'center', alignItems: 'center'},
  storeMapBox: {
    flexDirection: 'row',
    borderWidth: 1,
    paddingHorizontal: 15,
    gap: 5,
    borderRadius: 20,
    alignSelf: 'center',
    justifyContent: 'center',
    paddingVertical: 4,
  },
  subHeaderTypo: {
    ...font.FontSize.fontH5,
    marginTop: -5,
    marginBottom: 5,
  },
  chatIcon: {
    marginTop: 10,
  },
});
